var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeoNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 208 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5390_26611)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72266 107.388L27.171 92.814L35.146 103.744L66.4555 59.2946L82.9964 71.3179L92.7437 59.2946L126.711 84.7985L159.202 22.4962L170.131 30.5117L199.668 2.4574",
    stroke: "url(#paint1_linear_5390_26611)",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M204 1V174C204 182.284 197.333 189 189.049 189H18.9966C10.7123 189 4 182.284 4 174V107.925C12.2701 102.951 17.5405 98.2717 25.1921 93.825C27.963 92.2146 29.3106 95.1898 30.6677 98.0754L35.7881 102.05C44.8383 96.9574 57.5969 65.5464 66.2517 60.925C68.955 59.4815 71.9855 62.6146 75.0029 65.7025L83.4702 70.325C90.1001 66.8801 84.7811 64.2849 91.4172 60.925C95.8249 58.6934 102.365 64.9529 108.964 71.3023L127.179 82.075C136.421 77.4734 149.134 28.7922 158.967 23.875C161.093 22.812 162.918 24.6134 164.755 26.4607L170.887 29.2C180.999 24.1041 192.869 6.76336 204 1Z",
    fill: "url(#paint2_linear_5390_26611)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5390_26611",
    x: 0,
    y: 1,
    width: 208,
    height: 196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5390_26611"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5390_26611",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5390_26611",
    x1: 104,
    y1: 1,
    x2: 104,
    y2: 189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE6587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F52D6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5390_26611",
    x1: 102.196,
    y1: 2.4574,
    x2: 102.196,
    y2: 107.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E786C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5390_26611",
    x1: 105.987,
    y1: 1,
    x2: 115.548,
    y2: 188.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8EAFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeoNext);
export default __webpack_public_path__ + "static/media/neo-next.cf6620f5816ea3fa5606d4abbeff8c71.svg";
export { ForwardRef as ReactComponent };